<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [stroke]="chartOptions.stroke!"
        [dataLabels]="chartOptions.dataLabels!"
        [yaxis]="chartOptions.yaxis!"
        [colors]="chartOptions.colors!"
        [labels]="chartOptions.labels!"
        [grid]="chartOptions.grid!"
        [legend]="chartOptions.legend!"
        [title]="chartOptions.title!"
        [subtitle]="chartOptions.subtitle!"
    ></apx-chart>
</div>